import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaDesktop, FaStop } from "react-icons/fa";
import LocalScreenSharingPreview from "./LocalScreenSharingPreview";
import * as webRTCHandler from "../../utils/webRTCHandler";
import { setScreenSharingUser } from "../../store/actions"; // Action to track screen sharer

const constraints = {
  audio: false,
  video: true,
};

const SwitchToScreenSharingButton = () => {
  const dispatch = useDispatch();
  const identity = useSelector((state) => state.identity);
  const screenSharingUser = useSelector((state) => state.screenSharingUser); // current screen sharer

  const [isScreenSharingActive, setIsScreenSharingActive] = useState(false);
  const [screenSharingStream, setScreenSharingStream] = useState(null);

  const handleScreenShareToggle = async () => {
    if (!isScreenSharingActive) {
      if (screenSharingUser && screenSharingUser !== identity) {
        alert(`${screenSharingUser} is already sharing their screen.`);
        return;
      }

      let stream = null;
      try {
        stream = await navigator.mediaDevices.getDisplayMedia(constraints);
      } catch (err) {
        // console.error("Error accessing screen share stream", err);
      }

      if (stream) {
        setScreenSharingStream(stream);
        webRTCHandler.toggleScreenShare(isScreenSharingActive, stream);
        setIsScreenSharingActive(true);
        dispatch(setScreenSharingUser(identity)); // set self as sharer
      }
    } else {
      webRTCHandler.toggleScreenShare(isScreenSharingActive);
      setIsScreenSharingActive(false);

      if (screenSharingStream) {
        screenSharingStream.getTracks().forEach((t) => t.stop());
        setScreenSharingStream(null);
      }

      dispatch(setScreenSharingUser(null)); // clear screen sharer
    }
  };

  return (
    <>
      <div className="video_button_container mdevice" onClick={handleScreenShareToggle}>
        {isScreenSharingActive ? (
          <FaStop className="video_button_icon active" />
        ) : (
          <FaDesktop className="video_button_icon" />
        )}
      </div>
      {isScreenSharingActive && (
        <LocalScreenSharingPreview stream={screenSharingStream} />
      )}
    </>
  );
};

export default SwitchToScreenSharingButton;
